module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0